import type { EmailServiceDocument } from 'models/emailService/EmailServiceDocument';
import type { EmailServicePreviewContent } from 'models/emailService/EmailServicePreviewState';
import type { EmailServiceRecipient } from 'models/emailService/EmailServiceRecipient';
import type { NextWorkflowError } from 'models/NextWorkflowError';
import type { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import type { HttpCall, IHttpClient } from 'utils/http/httpClient.model';

export interface EmailServiceSubmitFormRequest {
  recipient: EmailServiceRecipient;
  documents: readonly EmailServiceDocument[];
  subject: string;
}

export interface SubmitFormResponse {
  errors: readonly string[];

  warnings: readonly string[];
}

export type EmailServiceReviewRequest = EmailServiceSubmitFormRequest;

export type EmailServicePreviewPayload = {
  emails?: readonly EmailServicePreviewContent[];
  errors: readonly NextWorkflowError[];
};

export interface EmailServiceApi {
  submit: (tradeId: string, request: EmailServiceSubmitFormRequest) => Observable<SubmitFormResponse>;

  preview: (
    tradeId: string,
    request: EmailServiceSubmitFormRequest,
  ) => Observable<HttpCall<EmailServicePreviewPayload>>;
}

export const emailServiceApiConnector = (http: IHttpClient): EmailServiceApi => {
  return {
    submit(tradeId: string, request: EmailServiceSubmitFormRequest): Observable<SubmitFormResponse> {
      return http
        .postJSON<SubmitFormResponse>({ url: `api/v3/documents/${tradeId}/do-send-email`, body: request })
        .pipe(map(r => r.payload));
    },
    preview: (
      tradeId: string,
      request: EmailServiceReviewRequest,
    ): Observable<HttpCall<EmailServicePreviewPayload>> => {
      return http.postJSON({
        url: `api/v3/documents/${tradeId}/do-preview-email`,
        body: request,
        tryParseErrorPayload: true,
      });
    },
  };
};
